import { render, staticRenderFns } from "./MainGGR.vue?vue&type=template&id=324d5f50"
import script from "./MainGGR.vue?vue&type=script&lang=ts"
export * from "./MainGGR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports